
import { Options, Vue } from "vue-class-component";
import { DownloadIcon } from "@heroicons/vue/solid";

@Options({
  components: {
    DownloadIcon,
  },
  computed: {
    informePaisVariables() {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return this.$store.state.informePaisVariables;
    },
  },
})
export default class Download extends Vue {}
